import { render, staticRenderFns } from "./LabInvoiceDetailAddSuggestList.vue?vue&type=template&id=58db2882&scoped=true&"
import script from "./LabInvoiceDetailAddSuggestList.vue?vue&type=script&lang=js&"
export * from "./LabInvoiceDetailAddSuggestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db2882",
  null
  
)

export default component.exports